import { useEffect } from 'react';

import { captureConsoleIntegration, init, reactRouterV6BrowserTracingIntegration, replayCanvasIntegration, replayIntegration } from '@sentry/react';
import { setInitialTags } from 'hooks/useSentryTags';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { isRunningTest } from 'utils/platform';
import { getReleaseName, getSentryEnvironment } from 'utils/sentry';

import {
  replaysOnErrorSampleRate,
  replaysSessionSampleRate,
  setBeforeSendCallback,
  setBeforeSendTransactionCallback,
  setInitialScope,
  tracesSampleRate
} from './helper';

const SENTRY_DSN = 'https://1d35ec857763465eb0162b204e4406c5@o514642.ingest.sentry.io/6547526';

export const initSentry = () => {
  if (isRunningTest) {
    return;
  }

  const environment = getSentryEnvironment();

  init({
    dsn: SENTRY_DSN,
    release: getReleaseName(),
    integrations: [
      reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      captureConsoleIntegration({
        levels: ['error']
      }),
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: true,
        block: ['kompis-keyboard'],
        unblock: ['.sentry-unblock, [data-sentry-unblock]'],
        unmask: ['.sentry-unmask, [data-sentry-unmask]']
      }),
      replayCanvasIntegration()
    ],
    sampleRate: 1.0,
    tracesSampleRate: tracesSampleRate(),
    environment,
    normalizeDepth: 5,
    replaysSessionSampleRate: replaysSessionSampleRate(),
    replaysOnErrorSampleRate: replaysOnErrorSampleRate(),
    beforeSend: setBeforeSendCallback(environment),
    beforeSendTransaction: setBeforeSendTransactionCallback(environment),
    ignoreErrors: [
      /^Failed to fetch$/,
      /^Failed to send .* event, TypeError: .*$/,
      /^TypeError: Failed to fetch$/,
      /^Load failed$/,
      /^ConnectionProblemException$/,
      /^GAID not found$/,
      /^Error loading gtag$/
    ]
  });

  setInitialTags();
  setInitialScope(environment);
};
